import React from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Cta } from "./components/Cta";
import { Link } from 'react-router-dom';

export const HomePage = () => {
    return (
        <>
        <Header />
        <main role="main">
        <div className="tmp-banner-one-area">
            <div className="container">
                <div className="banner-one-main-wrapper">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-lg-2">
                            <div className="banner-right-content">
                                <img className="tmp-scroll-trigger tmp-zoom-in animation-order-1" width={900} height={1088} fetchPriority="high" src="assets/images/hero-1b.webp" alt="izrada sajtova cena" />
                                <h2 className="banner-big-text-1 up-down">WEB DESIGNER</h2>
                                <h2 className="banner-big-text-2 up-down-2">WEB DESIGNER</h2>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="inner">
                                <span className="sub-title tmp-scroll-trigger tmp-fade-in animation-order-1">Jasna Cena</span>
                                <h1 className="title tmp-scroll-trigger tmp-fade-in animation-order-2 mt--5">Izrada Web Sajta <br />
                                    <span className="header-caption">
                                        <span className="cd-headline clip is-full-width">
                                            <span className="cd-words-wrapper">
                                                <b className="is-visible theme-gradient">Uz jasnu Cenu.</b>
                                                <b className="is-hidden theme-gradient">Web Developer.</b>
                                                <b className="is-hidden theme-gradient">UI/UX Designer.</b>
                                                <b className="is-hidden theme-gradient">Freelancer.</b>
                                                <b className="is-hidden theme-gradient">Content Writer.</b>
                                            </span>
                                    </span>
                                    </span>
                                </h1>
                                <p className="disc tmp-scroll-trigger tmp-fade-in animation-order-3"> Naš tim kombinuje moderni dizajn, performanse i SEO strategiju kako biste dobili sajt koji donosi klijente. Uz transparentne pakete približavamo vam tačnu cenu izrade web sajta i proces rada. <strong>Cene izrade sajta već od 100€ za jednostrani sajt - Landing Page</strong>. Za detaljnije informacije kontaktirajte nas kako bi vam poslali konkretnu ponudu.</p>
                                <div className="button-area-banner-one tmp-scroll-trigger tmp-fade-in animation-order-4">
                                    <Link to="/kontakt" className="tmp-btn hover-icon-reverse radius-round" >
                                        <span className="icon-reverse-wrapper">
                                            <span className="btn-text">Besplatne konsultacije</span>
                                        <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                        <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Tpm Latest Service Area Start */}
        <section className="latest-service-area mt--80">
            <div className="container">
                <div className="section-head mb--50">
                    <div className="section-sub-title center-title tmp-scroll-trigger tmp-fade-in animation-order-1">
                        <span className="subtitle">Naš Proces</span>
                    </div>
                    <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2">Proces izrađivanja
                        <br /> Projekta
                    </h2>
                    <p className="description section-sm tmp-scroll-trigger tmp-fade-in animation-order-3"> Naš proces pripreme i razvoja projekata se sastoji od nekoliko koraka. Pažljivo pripremamo svaki projekat. </p>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-1">
                            <h2 className="service-card-num"><span>01.</span>Strategija i istraživanje</h2>
                            <p className="service-para">Analiziramo konkurenciju, publiku i prilike za ključnu reč "izrada web sajta cena" da bismo definisali jasne ciljeve.</p>
                        </div>
                        <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-2">
                            <h2 className="service-card-num"><span>02.</span>Dizajn i UX</h2>
                            <p className="service-para">Kreiramo modernu vizuelnu priču i korisničko iskustvo koje vodi posetioce ka konverzijama.</p>
                        </div>
                        <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-3">
                            <h2 className="service-card-num"><span>03.</span>Razvoj i optimizacija</h2>
                            <p className="service-para">Gradimo performantne, sigurnosno proverene sajtove koji su spremni za SEO i marketing kampanje.</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="service-card-user-image">
                            <img className="tmp-scroll-trigger tmp-zoom-in animation-order-1" width={1200} height={1205} loading="lazy" src="assets/images/home-2.webp" alt="izrada web sajta cena" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* Tpm Latest Service Area End */}


        {/* Tpm Education Experience Area Start */}
        <section className="education-experience tmp-section-gapTop">
            <div className="container">
                <div className="section-head mb--50">
                    <div className="section-sub-title center-title tmp-scroll-trigger tmp-fade-in animation-order-1">
                        <span className="subtitle">Zašto mi?</span>
                    </div>
                    <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2">Zašto klijenti biraju 
                        <br /> nas za izradu web sajta
                    </h2>
                    <p className="description section-sm tmp-scroll-trigger tmp-fade-in animation-order-3">Fokusirani smo na rezultate i optimizaciju za ključne stvari u nasem radu, kako biste vi iskočili ispred konkurencije.</p>
                </div>
                <h2 className="custom-title mb-32 tmp-scroll-trigger tmp-fade-in animation-order-1">Prednosti rada sa nama <span><img
                            src="assets/images/custom-line/custom-line.png" width={81} height={6} loading="lazy" alt="custom-line" /></span>
                </h2>
                <div className="row g-5">
                    <div className="col-lg-6 col-sm-6">
                        <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-1">
                            {/* <h4 className="edu-sub-title">Trainer Marketing</h4> */}
                            <h2 className="edu-title">Transparentne ponude bez skrivenih troškova</h2>
                            <p className="edu-para">Naši ponude su transparentne, a skriveni troškovi nisu dozvoljeni. Nudimo iskrene i tačne ponude za svakog klijenta.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-2">
                            {/* <h4 className="edu-sub-title">Assistant Director</h4> */}
                            <h2 className="edu-title">Fleksibilni paketi u skladu sa potrebama i budžetom</h2>
                            <p className="edu-para">Nudimo fleksibilne pakete u skladu sa potreba i budžetom svakog klijenta. Naši paketi su prilagođeni svim potrebama i budžetima.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-3">
                            {/* <h4 className="edu-sub-title">Design Assistant</h4> */}
                            <h2 className="edu-title">Specijalne pogodnosti za startape i mala preduzeća</h2>
                            <p className="edu-para">Nudimo specijalne pogodnosti za startape i mala preduzeća. Prilagodjavamo nasu ponudu u skladu sa potreba i budžetom svakog klijenta.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-4">
                            {/* <h4 className="edu-sub-title">Design Assistant</h4> */}
                            <h2 className="edu-title">Veliko iskustvo na mnogobrojnim projektima</h2>
                            <p className="edu-para">Iskoristite naše iskustvo. Pomažemo svakom klijentu u digitilizaciji svojih ideja i idejnih projekata.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* Tpm Education Experience Area End */}


        {/* Tpm My Skill Area Start */}
        <section className="my-skill tmp-section-gapTop pb--100 pb_sm--50">
            <div className="container">
                <div className="section-head text-align-left mb--50">
                    <div className="section-sub-title tmp-scroll-trigger tmp-fade-in animation-order-1">
                        <span className="subtitle">Naše usluge</span>
                    </div>
                    <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2">Usluge koje pružamo</h2>
                </div>
                <div className="services-widget v1">
                    <div className="service-item current tmp-scroll-trigger tmp-fade-in animation-order-1">
                        <div className="my-skill-card">
                            <div className="card-icon">
                                {/* <i className="fa-light fa-building-columns"></i> */}
                                {/* <svg viewBox="0 0 24 24" width={36} fill="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 stroke-current"><path d="M12 3l1.5 3.8 3.5.6-2.7 2.6.7 3.6L12 12.6 9 13.9l.7-3.6L7 7.4l3.5-.6L12 3z"></path><path d="M5 4l.6 1.6 1.4.2-1 .9.3 1.6-1.3-.7-1.3.7.3-1.6-1-.9 1.4-.2L5 4z"></path><path d="M19 15l.8 2 1.7.3-1.3 1.2.3 1.8-1.5-.8-1.5.8.3-1.8-1.3-1.2 1.7-.3L19 15z"></path></svg> */}
                                <i className="fa-light fa-pen-nib"></i>
                            </div>
                            <div className="card-title">
                                <h3 className="main-title">Custom izrada web sajta</h3>
                                {/* <p className="sub-title">21 Done</p> */}
                            </div>
                            <p className="card-para">Potpuno prilagođeni dizajn i funkcionalnosti koje odgovaraju vašem brendu i poslovnim ciljevima.</p>
                            {/* <a href="#" className="read-more-btn">Read More <span className="read-more-icon"><i
                            className="fa-solid fa-angle-right"></i></span></a> */}
                        </div>
                       
                    </div>
                    <div className="service-item tmp-scroll-trigger tmp-fade-in animation-order-2">
                        <div className="my-skill-card">
                            <div className="card-icon">
                                <i className="fa-light fa-shopping-bag"></i>
                            </div>
                            <div className="card-title">
                                <h3 className="main-title">E-commerce rešenja</h3>
                                {/* <p className="sub-title">21 Done</p> */}
                            </div>
                            <p className="card-para">Postavljanje online prodavnice sa sigurnim plaćanjem, integracijama i automatskim procesima.</p>
                            {/* <a href="#" className="read-more-btn">Read More <span className="read-more-icon"><i
                            className="fa-solid fa-angle-right"></i></span></a> */}
                        </div>
                        
                    </div>
                    <div className="service-item tmp-scroll-trigger tmp-fade-in animation-order-3">
                        <div className="my-skill-card">
                            <div className="card-icon">
                                <i className="fa-light fa-code"></i>
                            </div>
                            <div className="card-title">
                                <h3 className="main-title">Popravka responsive dizajna</h3>
                                {/* <p className="sub-title">20 Done</p> */}
                            </div>
                            <p className="card-para">Vaš sajt izgleda savršeno na svim uređajima zahvaljujući responsive dizajnu i brzim performansama.</p>
                            {/* <a href="#" className="read-more-btn">Read More <span className="read-more-icon"><i
                            className="fa-solid fa-angle-right"></i></span></a> */}
                        </div>
                    </div>
                    <div className="service-item tmp-scroll-trigger tmp-fade-in animation-order-3">
                        <div className="my-skill-card">
                            <div className="card-icon">
                                <i className="fa-light fa-comments"></i>
                            </div>
                            <div className="card-title">
                                <h3 className="main-title">Održavanje i podrška</h3>
                                {/* <p className="sub-title">20 Done</p> */}
                            </div>
                            <p className="card-para">Kontinuirano unapređenje, sigurnosne provere i podrška kako bi vaš sajt uvek bio online.</p>
                            {/* <a href="#" className="read-more-btn">Read More <span className="read-more-icon"><i
                            className="fa-solid fa-angle-right"></i></span></a> */}
                        </div>
                    </div>
                    <div className="service-item tmp-scroll-trigger tmp-fade-in animation-order-3">
                        <div className="my-skill-card">
                            <div className="card-icon">
                                <i className="fa-light fa-line-chart"></i>
                            </div>
                            <div className="card-title">
                                <h3 className="main-title">SEO optimizacija</h3>
                                {/* <p className="sub-title">20 Done</p> */}
                            </div>
                            <p className="card-para">Strategijski pristup optimizaciji da ključna fraza "izrada web sajta cena" donese organski saobraćaj i konverzije.</p>
                            {/* <a href="#" className="read-more-btn">Read More <span className="read-more-icon"><i
                            className="fa-solid fa-angle-right"></i></span></a> */}
                        </div>
                    </div>
                    <div className="service-item tmp-scroll-trigger tmp-fade-in animation-order-3">
                        <div className="my-skill-card">
                            <div className="card-icon">
                                <i className="fa-light fa-globe"></i>
                            </div>
                            <div className="card-title">
                                <h3 className="main-title">Google Oglašavanje</h3>
                                {/* <p className="sub-title">20 Done</p> */}
                            </div>
                            <p className="card-para">Oglašavanje na Google, kreiranje i praćenje kampanje, kako bi vas sajt bio na vrhu u rezultatima pretrage.</p>
                            {/* <a href="#" className="read-more-btn">Read More <span className="read-more-icon"><i
                            className="fa-solid fa-angle-right"></i></span></a> */}
                        </div>
                    </div>

                </div>
            </div>
        </section>
        {/* Tpm My Skill Area End */}

        <Cta />

        </main>

        <Footer />
        </>
    );
}